import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import {Link} from "react-router-dom";
import {Button} from "reactstrap";
import Edit from "@material-ui/icons/Edit";
import CalendarToday from "@material-ui/icons/CalendarToday";


export default class PrefersSooner extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Tickets._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_TICKET_SOONER'
	}

	fetchData = async (state) => {
		if (this.props.forDispatch) {
			return;
		}
		if (this.props.isModal) {
			this.state.limit = 10;
			this.limit = 10;
		}
		if (typeof(this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		if (this.props.filter) {
			this.state.filter.filterByRecent = this.props.filter.filterByRecent
			this.state.filter.filterRegion = this.props.filter.filterRegion
			this.state.filter.filterDate = this.props.filter.filterDate ?? moment().add().format('YYYY-MM-DD');
		}
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns;
		columns = this.props.forDispatch ? [
			{
				Header: "Date",
				id: "created",
				width: 110,
				accessor: obj => moment(obj.created).local().format("MM/DD/YYYY")
			},
			{
				Header: "Notes",
				id: "notes",
				accessor: obj => (obj.notes)
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							<Link to={"/dispatch/calendar/" + props.original.pkey} target={"_blank"}>
								<Button color="primary" size={"sm"} block={true} onClick={() => {
									//so the window pops up
									localStorage.setItem('ticketToggled', 'no');
									localStorage.removeItem('users'); //doing this so that ticket correctly pops after creation no matter what
									localStorage.removeItem('regions'); //doing this so that ticket correctly pops after creation no matter what
									localStorage.removeItem('date'); //doing this so that ticket correctly pops after creation no matter what
								}}>
									<CalendarToday fontSize={'small'}/></Button>
							</Link>
						</span>
					);
				}
			}
		] : [
			{
				Header: "Date",
				id: "created",
				width: 110,
				accessor: obj => moment(obj.created).local().format("MM/DD/YYYY")
			},
			{
				Header: "Phone Number",
				id: "phone_number",
				width: 130,
				accessor: obj => (obj.phone_number)
			},
			{
				Header:"Region",
				id: "region",
				accessor: obj => (obj.region)
			},
			{
				Header:"City",
				id: "city",
				accessor: obj => (obj.city)
			},
			{
				Header:"State",
				id: "state",
				width: 80,
				accessor: obj => (obj.state)
			},
			{
				Header:"ZIP",
				id: "zip",
				width: 80,
				accessor: obj => (obj.zip),
				Cell: (props) => {
					if (!props.original.zip) {
						return (
							<span>N/A</span>
						);
					}

					return (
						<span>
							<a href={`https://www.google.com/maps/dir/${props.original.zip}`} target={"_blank"}>
								{props.original.zip}
							</a>
						</span>
					);
				}
			},
			{
				Header: "Notes",
				id: "notes",
				accessor: obj => (obj.notes)
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							<Link to={"/dispatch/calendar/" + props.original.pkey} target={"_blank"}>
								<Button color="primary" size={"sm"} block={true} onClick={() => {
									//so the window pops up
									localStorage.setItem('ticketToggled', 'no');
									localStorage.removeItem('users'); //doing this so that ticket correctly pops after creation no matter what
									localStorage.removeItem('regions'); //doing this so that ticket correctly pops after creation no matter what
									localStorage.removeItem('date'); //doing this so that ticket correctly pops after creation no matter what
								}}>
									<CalendarToday fontSize={'small'}/></Button>
							</Link>
						</span>
					);
				}
			}
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Prefers Sooner')}
							{this.renderHeaderRight("Phone_Logs", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={this.props.forDispatch ? this.props.dispatchData : data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: false,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 10, 15, 20, 50]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
